import styled from "styled-components"
import Button from "@irati/ui/src/Button"

const StyledButton = styled(Button)`
  display: inline-block;
  float: right;
`

export default StyledButton
